import { IQueryParamsBaseRecord, defaultQueryParamsBase } from "common/records/index/QueryParamsBase";
import { AssociationType, Nullable, ORG } from "common/types";
import { Record } from "immutable";

export const folderParamsFromJSON = (data: IFolderParamsData) => {
  const record = { ...(data as any) };

  return new FolderParamsRecord(record);
};

export interface IFolderParamsData extends Partial<IQueryParamsBaseRecord> {
  id: Nullable<number>;
  folderable_id?: number;
  folderable_type: AssociationType;
}

export interface IFolderParamsRecord extends IQueryParamsBaseRecord {
  id: Nullable<number>;
  folderable_id: Nullable<number>;
  folderable_type: AssociationType;
}

const defaultFolderParams: IFolderParamsRecord = {
  ...defaultQueryParamsBase,
  id: null,
  folderable_id: null,
  folderable_type: ORG,
};

export class FolderParamsRecord extends Record(defaultFolderParams) implements IFolderParamsRecord {}
